import clsx from '@vangst/lib/clsx'
import useMember from '@vangst/services/oogst/member/useMember'
import useMemberJobApplications, {
  MemberJobApplicationsOptions,
  MemberJobApplicationsVars,
} from '@vangst/services/oogst/member/useMemberJobApplications'
import Routes from '@vangst/services/routes'
import { memo } from 'react'
import { MdSearch, MdTouchApp } from 'react-icons/md'
import Spin from '../../components/assets/Spinner'
import EmptyState from '../../components/feedback/EmptyState'
import ClickyLink from '../../components/navigation/ClickyLink'
import Counter from '../../components/views/Counter'
import MemberJobApplicationRenderer from './MemberJobApplicationRenderer'

type PropsType = React.HTMLAttributes<HTMLDivElement> & {
  readonly as: 'avatar' | 'card' | 'slip' // | 'header'
  readonly at: 'infinite' | 'preview' | 'sidebar'
  readonly classNameList?: string
  readonly take?: number
  readonly variables: MemberJobApplicationsVars
  readonly options?: MemberJobApplicationsOptions
}

// TODO: This endpoint should probably paginate from the API
function MemberJobApplicationsGrid(props: PropsType) {
  const { as, at, classNameList, take, variables, options, ...rest } = props
  const { data: dataMember } = useMember(variables)
  const { data, isLoading, uri } = useMemberJobApplications(variables, options)
  const member = dataMember?.getUser
  const externalUser = !member?.candidate?.permissions?.readApplications
  const jobApplications = data?.getUser.candidate?.jobApplications
  // TODO: This endpoint will change which is why we aren't deriving it yet
  const isZero = jobApplications?.length === 0
  const canTake = take != null && (at === 'preview' || at === 'sidebar')
  // const pages = canTake && data?.pages ? [data.pages[0]] : data?.pages
  const pages =
    canTake && jobApplications
      ? jobApplications.slice(0, take)
      : jobApplications

  return (
    <div {...rest}>
      {at === 'sidebar' && (
        <p className="relative mb-4 text-sm">
          <ClickyLink className="link-blue-dark mr-2" href={uri}>
            View Applications
          </ClickyLink>
          {jobApplications ? <Counter to={jobApplications.length || 0} /> : ''}
          {isLoading && (
            <Spin className="absolute right-0 top-0" width={16} height={16} />
          )}
        </p>
      )}

      {at === 'infinite' && (
        <p className="relative mb-4">
          <span className="mr-2">Results</span>
          {jobApplications ? <Counter to={jobApplications.length || 0} /> : ''}
          {isLoading && (
            <Spin className="absolute right-0 top-0" width={16} height={16} />
          )}
        </p>
      )}
      <ul
        className={clsx(
          'min-h-40 w-full',
          !isZero && classNameList,
          !externalUser && 'min-h-0',
        )}
      >
        {isZero && !externalUser && (
          <li>
            <EmptyState
              className="sm:h-60"
              icon={member?.candidate?.isAbleToApply ? MdSearch : MdTouchApp}
              loading={isLoading}
            >
              {member?.candidate?.isAbleToApply ? (
                <span>
                  Search for and apply for the greatest jobs in the Cannabis
                  industry.{' '}
                  <ClickyLink
                    className="link-blue-dark mt-2"
                    href={Routes.JOBS}
                  >
                    Search Jobs
                  </ClickyLink>
                </span>
              ) : (
                <span>
                  You must have a complete profile to enable 1 Click Apply.{' '}
                  <ClickyLink
                    className="link-blue-dark mt-2"
                    href={member?.routes?.edit || Routes.DASHBOARD}
                  >
                    {' '}
                    Click here to complete your profile.
                  </ClickyLink>
                </span>
              )}
            </EmptyState>
          </li>
        )}

        {pages?.map((node) => {
          return (
            <li key={node.id}>
              <MemberJobApplicationRenderer as={as} jobApplication={node} />
            </li>
          )
        })}
      </ul>
    </div>
  )
}

export default memo(MemberJobApplicationsGrid)
